import Container from 'react-bootstrap/Container';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Header';
import LoadingSpinnerUrl from '../../assets/loading.svg';

const Loading = () => {
  const { t } = useTranslation('commons');
  return (
    <Fragment>
      <Header />
      <Container className="mt-4 d-flex justify-content-center">
        <div className="text-center">
          <img alt="LoadingSpinner" src={LoadingSpinnerUrl} />
          <h4>{t('loading')}</h4>
        </div>
      </Container>
    </Fragment>
  );
};

export default Loading;
